import Phaser from 'phaser';
import { gameConfig } from './config/game';
import './styles.css';
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';
import { StartScene } from './scenes/StartScene';
import { LevelScene } from './scenes/LevelScene';
import { InvitationScene } from './scenes/InvitationScene';

new Phaser.Game({ ...gameConfig, scene: [BootScene, PreloadScene, StartScene, LevelScene, InvitationScene] });
